import BorrowAmount from "../BorrowAmount";

export default function Principal() {
    return <BorrowAmount />;
}
